export default {
  title: "Exercise Questionnaire",
  message: "The information you provide helps us tailor this exercise to your situation.",
  selectPlaceholder: "— Please choose —",
  buttons: {
    submit: "Start Exercise",
    cancel: "Cancel",
    close: "Close",
    edit: "Edit Questionnaire",
    view: "View Questionnaire",
  },
  success: "Your answers have been saved.",
  errors: {
    loadFailed: "Failed to load form",
    submitFailed: "Failed to submit form",
  },
};
